module.exports = __webpack_public_path__ + "static/img/banner05.9f7944e5.png";